import React from "react";

import InstagramEmbed from "react-instagram-embed";

const Instagram = ({ urlUri, alt }) => {
  return (
    <div className="rca-embed-platform instagram" title={alt || urlUri}>
      <InstagramEmbed
        url={urlUri}
        maxWidth={"100%"}
        hideCaption={false}
        containerTagName="div"
        protocol=""
        injectScript
        onLoading={() => {}}
        onSuccess={() => {}}
        onAfterRender={() => {}}
        onFailure={() => {}}
      />
    </div>
  );
};

export default Instagram;
